import { useRouter } from 'vue-router'
import { ItemType, type Item } from '@/shared/graphql/legacy/generated'
import { useMobileSearchStore } from '@/features/search/store'
import { isItemInactive } from '@/features/search/utils'

export const useSearchNavigation = () => {
  const router = useRouter()
  const store = useMobileSearchStore()

  const goToItem = (item: Item) => {
    if (isItemInactive(item)) return

    if (item.type === ItemType.Folder) {
      router.push(`/home${item.parentPath}/${item.name}`.replace('//', '/'))
    } else if (item.file) {
      router.push(`/file/${item.file.copyrightId}`)
    }
    store.close()
  }

  return { goToItem }
}
